import request from '@/utils/request'

let specialApi = {
  /*秒杀活动列表*/
  activeList(data) {
    return request._post('/shop/plus.special.Active/index', data);
  },
  /*添加秒杀活动*/
  addActive(data) {
    return request._post('/shop/plus.special.Active/add', data);
  },
  /*获取秒杀活动数据*/
  getActive(data) {
    return request._get('/shop/plus.special.Active/edit', data);
  },
  /*保存秒杀活动*/
  saveActive(data) {
    return request._post('/shop/plus.special.Active/edit', data);
  },
  /*删除秒杀活动*/
  delActive(data) {
    return request._post('/shop/plus.special.Active/delete', data);
  },
  /*查看商品*/
  seeActive(data) {
    return request._post('/shop/plus.special.Active/see', data);
  },

  /*添加商品*/
  addProduct(data) {
    return request._post('/shop/plus.special.Product/add', data);
  },
  /*获取活动已选商品*/
  selectProduct(data) {
    return request._post('/shop/plus.special.Product/selectProduct', data);
  },
  /*秒杀商品详情*/
  detail(data) {
    return request._post('/shop/plus.special.Product/detail', data);
  },
  /*保存秒杀商品*/
  saveData(data) {
    return request._post('/shop/plus.special.Product/saveData', data);
  },
  delProduct(data) {
    return request._post('/shop/plus.special.Product/delete', data);
  },

  /*保存设置*/
  saveSetting(data) {
    return request._post('/shop/plus.special.Setting/index', data);
  },
  /*获取设置*/
  getSetting(data) {
    return request._get('/shop/plus.special.Setting/index', data);
  },
  /*获取设置*/
    getDiySkill(data) {
    return request._post('/shop/plus.special.Active/getDiyProduct', data);
},
}
export default specialApi;



// WEBPACK FOOTER //
// ./src/api/special.js